import React from 'react';
import { FileTextIcon, CalculatorIcon, MapPinIcon, ClipboardListIcon, GiftIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: FileTextIcon,
    title: 'La Guía Maestra Solo-Survival (PDF)',
    description: '45 páginas de tácticas de guerrilla para Santiago y Regiones.',
    isBonus: false
  }, {
    icon: CalculatorIcon,
    title: 'Calculadora Excel de gastos por compra y gastos mensuales',
    description: 'Para que sepas exactamente cuánto estás gastando mensual en supermercado, feria, gastos hormigas y empezar a ahorrar.',
    isBonus: false
  }, {
    icon: MapPinIcon,
    title: 'Mapa de Mayoristas de Chile',
    description: 'Dónde ir y qué comprar exactamente en Alvi, Mayorista 10 y Central Mayorista.',
    isBonus: false
  }, {
    icon: ClipboardListIcon,
    title: 'Planificador de Compra Inteligente',
    description: 'La lista que bloquea las compras por impulso a las 19:00 hrs.',
    isBonus: false
  }, {
    icon: GiftIcon,
    title: 'BONO: Mini-guía "Zero Waste"',
    description: 'Para que nada vuelva a morir en tu refrigerador.',
    isBonus: true
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-282">
      <div className="max-w-6xl mx-auto" data-id="element-283">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-12 text-center" data-id="element-284">
          Todo lo que incluye tu Protocolo
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-285">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className={`bg-[#f8fafc] rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow ${item.isBonus ? 'border-2 border-[#fbbf24]' : ''}`} data-id="element-286">
                <div className="flex items-start gap-4" data-id="element-287">
                  <div className={`p-3 rounded-lg flex-shrink-0 ${item.isBonus ? 'bg-[#fbbf24]' : 'bg-[#1a2332]'}`} data-id="element-288">
                    <Icon className={`w-6 h-6 ${item.isBonus ? 'text-[#1a2332]' : 'text-white'}`} data-id="element-289" />
                  </div>
                  <div data-id="element-290">
                    <h3 className="text-xl font-bold text-[#1a2332] mb-2" data-id="element-291">
                      {item.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed" data-id="element-292">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}